import View from './image-view'
import Model from './image-model'
import addMenu from './image-add-menu'

export default {
	View,
	Model,
	addMenu
}
